import _ from "lodash";
import { AUTO_SMS_KEY } from "../../../constants";
import { getSentSMSByName } from "./getSentSMS";

const camelCaseToLowerCaseWithSpaces = (str) => str?.replace(/([A-Z])/g, " $1").toLowerCase() ?? "";

function getSMSLogs() {
  return (id, clientAppointments, smsType, sinceTs = 0) => {
    let logs = [];
    const sms = _.get(
      _.find(clientAppointments, (ca) => ca.id === id),
      smsType,
      null
    );
    if (_.isEmpty(sms)) {
      return [];
    }
    const sentAutoSMS = sms?.sent;
    if (smsType === "sms" && sentAutoSMS) {
      const initialFirstSms = getSentSMSByName(sentAutoSMS, AUTO_SMS_KEY.INITIAL);
      const initialSecondSms = getSentSMSByName(sentAutoSMS, AUTO_SMS_KEY.INITIAL_SECOND);
      const initialThirdSms = getSentSMSByName(sentAutoSMS, AUTO_SMS_KEY.INITIAL_THIRD);
      const secondSms = getSentSMSByName(sentAutoSMS, AUTO_SMS_KEY.SECOND);
      const thirdSms = getSentSMSByName(sentAutoSMS, AUTO_SMS_KEY.THIRD);
      const fourthSms = getSentSMSByName(sentAutoSMS, AUTO_SMS_KEY.FOURTH);
      [initialFirstSms, initialSecondSms, initialThirdSms, secondSms, thirdSms, fourthSms].forEach((autoSMS) => {
        if (autoSMS && Number(autoSMS.sentTime) >= sinceTs) {
          logs.push({
            name: autoSMS.name,
            ts: autoSMS.sentTime,
            text: autoSMS.content || `${camelCaseToLowerCaseWithSpaces(autoSMS.name)} SMS sent`,
          });
        }
      });
    }

    if (smsType === "manual_sms") {
      const manualSentLogs = _.get(sms, "sent", []);
      manualSentLogs.forEach((log) => {
        logs.push({
          ts: log.time || log,
          text: log.msg || "Manual SMS sent",
        });
      });
    }

    if (_.has(sms, "received")) {
      const receivedSMS = Object.entries(sms.received)
        .filter(([ts, text]) => {
          if (Number(ts) < sinceTs) {
            return false;
          }
          if (_.isNil(text)) {
            return false;
          }
          if (typeof text === "string") {
            return text.trim().length > 0;
          }
          return true;
        })
        .map((rec) => ({
          ts: Number(rec[0]),
          text: rec[1],
          patient: true,
        }));
      logs = logs.concat(receivedSMS);
    }
    logs = _.orderBy(logs, ["ts"], ["asc"]);
    return logs;
  };
}

export default getSMSLogs();
